// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Map', {toJSON: require('./$.collection-to-json')('Map')});


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/core-js/library/modules/es7.map.to-json.js
 ** module id = 2854
 ** module chunks = 0
 **/